module.exports = __webpack_public_path__ + "static/javascript-e8118ebac49da3411a4d9010d5fce7b3.png";